import { render, staticRenderFns } from "./swapAccountsModal.vue?vue&type=template&id=24325e58&scoped=true"
import script from "./swapAccountsModal.vue?vue&type=script&lang=js"
export * from "./swapAccountsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24325e58",
  null
  
)

export default component.exports